import { createSlice } from 'utils/@reduxjs/toolkit';
import { ShapeValidationState } from './types';
import { reducers } from './reducers';

export const initialState: ShapeValidationState = {
  data: {
    hasShapeError: false,
    shapeErrors: [],
    fieldsWithErrors: [],
  },
  isLoading: false,
  error: null,
};

const slice = createSlice({
  name: 'shapeValidation',
  initialState,
  reducers,
});

export const { actions: shapeValidationActions } = slice;
export const { reducer: shapeValidationReducer } = slice;
